/** Append-only equipment for the full-body studio. Keys name rendering styles. */
export interface CharacterItem {
  key: string;
  label: string;
  lvl: number;
  px: string[];
  /** New starter choices must not alter the original default identity pool. */
  derived?: false;
}
const item = (key: string, label: string, lvl: number, px: string[] = []): CharacterItem => ({ key, label, lvl, px, derived: false });
const torso = (...rows: string[]) => [...Array<string>(11).fill(''), ...rows];

export const CHARACTER_KITS = [
  item('bomber', 'Bomber jacket', 2, torso('...MMMMMMMMMM...', '..MMKKM..MKKMM..', '..MM..M..M..MM..', '..MM..M..M..MM..', '...MMMMAAMMMM...')),
  item('labcoat', 'Lab coat', 6, torso('...WWWWWWWWWW...', '..WWWK....KWWW..', '..WWWWK..KWWWW..', '..WWWW.KK.WWWW..', '..WWWW.KK.WWWW..')),
  item('apron', 'Workshop apron', 3, torso('.....MM..MM.....', '.....MMMMMM.....', '....MMMMMMMM....', '....MM.AA.MM....', '....MMMMMMMM....')),
  item('varsity', 'Varsity jacket', 4, torso('...MMMMMMMMMM...', '..WWM......MWW..', '..WWM.A....MWW..', '..WWM......MWW..', '...MMMMMMMMMM...')),
  item('raincoat', 'Raincoat', 7, torso('...MMMMMMMMMM...', '..MM..M..M..MM..', '..MM...MM...MM..', '..MM...MM...MM..', '..MMMMMAMMMMMM..')),
  item('utility', 'Utility suit', 10, torso('...MMMMMMMMMM...', '..MMK......KMM..', '..MMMM....MMMM..', '..MMK......KMM..', '..MMMMMAMMMMMM..')),
  item('poncho', 'Poncho', 0, torso('....MMMMMMMM....', '...MMMMMMMMMM...', '..MMMMMMMMMMMM..', '.MMMMMMAAMMMMMM.', '..MMMMMMMMMMMM..')),
  item('spacesuit', 'Space suit', 24, torso('...WWWWWWWWWW...', '..WWKKWWWWKKWW..', '..WWWWAAAAWWWW..', '..WWWWKKKKWWWW..', '..WWWWWWWWWWWW..')),
];

export const CHARACTER_HATS = [
  item('none', 'No headwear', 0),
  item('softcap', 'Everyday cap', 0, ['', '....GGGGGGGG....', '...GGGGGGGGGG...', '..GGGGGGGGGGGG..']),
  item('knit', 'Knit beanie', 2, ['......GGGG......', '....GGGGGGGG....', '...GGGGGGGGGG...', '...gggggggggg...']),
  item('hardhat', 'Hard hat', 5, ['.....HHHHHH.....', '....HHhHHhHH....', '...HHHhHHhHHH...', '..HHHHHHHHHHHH..']),
  item('beret', 'Beret', 4, ['', '.....GGGGGGGG...', '...GGGGGGGGGGG..', '...gggggggg.....']),
  item('crown', 'Builder crown', 16, ['...H..H..H..H...', '...HHHHHHHHHH...', '...HHhHHhHHHH...', '....HHHHHHHH....']),
  item('helmet', 'Space helmet', 24, ['....WWWWWWWW....', '...WVVVVVVVVW...', '..WVVVVVVVVVVW..', '..WV........VW..', '..WV........VW..', '..WV........VW..', '..WV........VW..', '..WV........VW..', '...W........W...', '....WWWWWWWW....']),
];

export const CHARACTER_PROPS = [
  item('none', 'Empty hands', 0), item('mug', 'Coffee mug', 0),
  item('notebook', 'Notebook', 0), item('laptop', 'Laptop', 3),
  item('wrench', 'Wrench', 5), item('plant', 'Little plant', 7),
  item('camera', 'Camera', 9), item('robot', 'Robot sidekick', 14),
  item('book', 'Reference book', 4), item('tablet', 'Drawing tablet', 11),
];

export const CHARACTER_BOOTS = [
  item('sneakers', 'Sneakers', 0), item('high tops', 'High tops', 2),
  item('workboots', 'Work boots', 5), item('runners', 'Running shoes', 0),
  item('moonboots', 'Moon boots', 24),
];
export const CHARACTER_COLORS = ['Graphite', 'Ocean', 'Coral', 'Moss', 'Violet', 'Sand'].map((label, i) => item(['graphite', 'ocean', 'coral', 'moss', 'violet', 'sand'][i]!, label, 0));
export const GARMENT_PALETTES = [
  { G: '#626b7a', g: '#343c4a', J: '#a7b0bf' },
  { G: '#428fce', g: '#245482', J: '#8fc8ec' },
  { G: '#d66f68', g: '#803f4a', J: '#f2a49a' },
  { G: '#6a9b83', g: '#36594c', J: '#a9cbb0' },
  { G: '#967bd2', g: '#58447d', J: '#c5b0ed' },
  { G: '#c2a16f', g: '#796444', J: '#ead8b0' },
];
export const CHARACTER_POSES = [
  item('still', 'Still', 0), item('breathe', 'Breathe & blink', 0),
  item('wave', 'Hello wave', 2), item('cheer', 'Victory cheer', 8),
  item('work', 'In the zone', 12),
];
